import React from 'react';
import './landfill-video.css'

const LandfillVideo = () => (
    <div dangerouslySetInnerHTML={{ __html: '<video autoPlay loop muted playsinline id="video"><source src="/assets/videos/landfill.mp4" type="video/mp4"/></video>' }} />
  );

export default LandfillVideo;  